import React from 'react';
import PropTypes from 'prop-types';
import { Grid, TextField } from '@material-ui/core';
import AuthTypeSelector from '../components/AuthTypeSelector';
import { AUTH_TYPES } from '../../../auth/auth.options';
import PasswordFieldsCollapse from '../components/PasswordFieldsCollapse';

const styles = {
  textfield: {
    marginBottom: '12px',
    width: '320px',
  },
};

const UserCredentialsSection = ({
  authOptions,
  record,
  validationErrors,
  disableForm,
  showPassword1,
  showPassword2,
  onToggleShowPassword1,
  onToggleShowPassword2,
  onFieldChange,
  onAuthTypeChange,
}) => {
  const authType = record.passwordEnabled
    ? AUTH_TYPES.LOCAL
    : AUTH_TYPES.MICROSOFT_SSO;

  const isLocalAuth = authType === AUTH_TYPES.LOCAL;

  const handleChange = (event) => {
    const { name, value } = event.target;
    onFieldChange(name, value);
  };

  const handleAuthTypeChange = (selected) => {
    const isLocal = selected === AUTH_TYPES.LOCAL;
    if (onAuthTypeChange) {
      onAuthTypeChange(selected);
    } else {
      // fallback: aggiorna i flag nel record
      onFieldChange('passwordEnabled', isLocal);
      onFieldChange('oauthEnabled', !isLocal);

      if (!isLocal) {
        onFieldChange('password', '');
        onFieldChange('confirmPassword', '');
      }
    }
  };

  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <AuthTypeSelector
          value={authType}
          options={authOptions}
          onChange={handleAuthTypeChange}
          disabled={disableForm}
        />
      </Grid>

      <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
        <Grid
          container
          direction="column"
          alignItems="center"
          style={{ paddingBottom: '10px' }}
        >
          <TextField
            id="email"
            label="Email"
            required
            value={record.email === null ? '' : record.email}
            name="email"
            onChange={handleChange}
            disabled={disableForm}
            style={styles.textfield}
            helperText={validationErrors.email}
            error={validationErrors.email.length > 0}
          />
          <PasswordFieldsCollapse
            open={isLocalAuth}
            disabled={disableForm}
            required={isLocalAuth}
            passwordValue={record.password}
            confirmPasswordValue={record.confirmPassword}
            passwordError={validationErrors.password}
            confirmPasswordError={validationErrors.confirmPassword}
            showPassword1={showPassword1}
            showPassword2={showPassword2}
            onToggleShowPassword1={onToggleShowPassword1}
            onToggleShowPassword2={onToggleShowPassword2}
            onChange={handleChange}
          />
        </Grid>
      </Grid>

      <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
        <Grid
          container
          direction="column"
          alignItems="center"
          style={{ paddingBottom: '10px' }}
        >
          <TextField
            id="nome"
            label="Nome"
            value={record.nome === null ? '' : record.nome}
            name="nome"
            onChange={handleChange}
            disabled={disableForm}
            style={styles.textfield}
          />
          <TextField
            id="cognome"
            label="Cognome"
            value={record.cognome === null ? '' : record.cognome}
            name="cognome"
            onChange={handleChange}
            disabled={disableForm}
            style={styles.textfield}
          />
          <TextField
            id="telefono"
            label="Telefono"
            value={record.telefono === null ? '' : record.telefono}
            name="telefono"
            onChange={handleChange}
            disabled={disableForm}
            style={styles.textfield}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

UserCredentialsSection.propTypes = {
  authOptions: PropTypes.array.isRequired,
  record: PropTypes.object.isRequired,
  validationErrors: PropTypes.object.isRequired,
  disableForm: PropTypes.bool.isRequired,
  showPassword1: PropTypes.bool.isRequired,
  showPassword2: PropTypes.bool.isRequired,
  onToggleShowPassword1: PropTypes.func.isRequired,
  onToggleShowPassword2: PropTypes.func.isRequired,
  onFieldChange: PropTypes.func.isRequired,
  onClearValidationErrors: PropTypes.func,
};

export default UserCredentialsSection;
